export interface AppProperties {
  sectorcode: string;
  appEigenaar: string;
  appNaam: string;
  appVersie: string;
  appTimeout: number; // int
  beheermodus: string;
  dbOmgeving: string;
  dbOmgevingKleur: string;
  securityDelay: number; // Long
}
